(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Promote a lazy slide image so it downloads before the visitor reaches it.
  const warm = (slide) => {
    const img = slide?.querySelector('img[loading="lazy"]');
    if (img) img.loading = 'eager';
  };

  // Init one hero per section; all lookups are scoped so several heroes never share controls.
  const initHero = (root) => {
    const el = root.querySelector('.lum-hero__swiper');
    if (!el || el.swiper) return;

    const swiper = new Swiper(el, {
      rewind: true,
      speed: 500,
      autoplay: reduceMotion
        ? false
        : { delay: 5000, disableOnInteraction: true, pauseOnMouseEnter: true },
      navigation: {
        prevEl: root.querySelector('.lum-hero__arrow--prev'),
        nextEl: root.querySelector('.lum-hero__arrow--next'),
      },
      pagination: {
        el: root.querySelector('.lum-hero__dots'),
        clickable: true,
      },
    });

    // Warm only the next slide: slide 2 after page load, then one ahead on every change.
    if (document.readyState === 'complete') {
      warm(swiper.slides[1]);
    } else {
      window.addEventListener('load', () => warm(swiper.slides[1]), { once: true });
    }
    swiper.on('slideChange', () => warm(swiper.slides[swiper.activeIndex + 1]));

    // Keyboard users get the same pause that mouse users get on hover (WCAG 2.2.2).
    if (swiper.autoplay) {
      root.addEventListener('focusin', () => swiper.autoplay.stop());
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll('.lum-hero').forEach(initHero);

  initAll();

  // Theme Editor re-renders the section on every edit; re-init the fresh markup.
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();




var PRESETS = {
    default: { base: 1.4, 540: 2.3, 768: 2.6, 1024: 3.6, 1280: 4.1 },
    full:    { base: 1.2, 540: 2,   768: 3,   1024: 4,   1280: 5.2   },
};

function initPswipers() {
    document.querySelectorAll('.lum-pswiper').forEach(function (el) {
        if (el.dataset.pswiperReady) return;   // already initialized
        el.dataset.pswiperReady = '1';
        var preset = PRESETS[el.dataset.slide] || PRESETS.default;
        new Swiper(el, {
            slidesPerView: preset.base,
            spaceBetween: 12,
            watchOverflow: true,
            navigation: {
                prevEl: el.querySelector('.lum-pswiper__arrow--prev'),
                nextEl: el.querySelector('.lum-pswiper__arrow--next'),
            },
            breakpoints: {
                540:  { slidesPerView: preset[540] },
                768:  { slidesPerView: preset[768] },
                1024: { slidesPerView: preset[1024] },
                1280: { slidesPerView: preset[1280] },
            },
        });
    });
}

// run once on load
initPswipers();

// run again when new sliders are injected (e.g. related products via AJAX)
document.addEventListener('lum:sliders:init', initPswipers);